import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import debounce from 'lodash.debounce';
import { Button, CloseButton, IconButton, Input, InputGroup, InputLeftElement, InputRightElement, useDisclosure } from "@chakra-ui/react";
import InputField from "components/fields/InputField";
import Modal from "components/modal/Modal";
import { FaEdit, FaPencilAlt, FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import TooltipComponent from "components/tooltip";
import { FiSearch } from "react-icons/fi";
import ButtonPrimary from "components/button/ButtonPrimary";
import { IoAddCircle, IoClose, IoEye, IoEyeOff, IoSearch } from "react-icons/io5";
import { SET_TO_DEFAULT_RESPONSE, create, update, del, getByPage } from "./../../../store/features/slices/userSlice";
import { message as alerta } from "utils/Funciones";
import { uriSerialized } from "utils/uriSerialized";
import { alertaConfirmar } from "utils/Funciones";
import SwitchToggle from "components/fields/SwitchToggle";
import { validarDNI } from "utils/Funciones";
import { getByDocumentId } from "store/features/slices/consultaReniecSlice";
import { SET_TO_DEFAULT_RESPONSE_CONSULTA_RENIEC } from "store/features/slices/consultaReniecSlice";
import AutoComplete from "components/autocomplete/AutoComplete";
import { MdPhotoCamera } from "react-icons/md";
import PhotoPreview from "components/imagenpreview/PhotoPreview";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { validarEMAIL } from "utils/Funciones";
import moment from 'moment';
import 'moment/locale/es';
import TablePagination from "./table/TablePagination";

const Usuarios = () => {
    const dispatch = useDispatch();
    const {
        userToken, 
        user,
        dataByPage,
        totalPage,
        totalRow,
        isMutation
    } = useSelector((state) => state.userReducer);

    const {
        isLoading: isLoadingConsultaReniec,
        responseGetByDocumentId
    } = useSelector((state) => state.consultaReniecReducer);

    const registrar = useDisclosure()
    const editar = useDisclosure()
    const [searchTerm, setSearchTerm] = useState('');
    const [VerPasswords, SetVerPasswords] = useState(
        {
            password: false,
        });
    const [state, setState] = useState({
        dni: '',
        salario_dia: 0,
        turno: '',
        name: '',
        direccion: '',
        email: '',
        password: '',
        autoridad: '',
        imagen: '',
        bloqueado: false
    })

    const [stateEdit, setStateEdit] = useState({
        _id: '',
        dni: '',
        salario_dia: 0,
        turno: '',
        name: '',
        direccion: '',
        email: '',
        password: '',
        autoridad: '',
        currentimagen: '',
        imagen: '',
        bloqueado: false
    })

    const [preview, setPreview] = useState({
        imagen: '',
    })

    const [previewEdit, setPreviewEdit] = useState({
        imagen: '',
    })

    const setDefaultState = () => {
        setState({
            ...state,
            dni: '',
            salario_dia: 0,
            turno: '',
            name: '',
            direccion: '',
            email: '',
            password: '',
            autoridad: '',
            imagen: '',
            bloqueado: false
        })

        setStateEdit({
            ...stateEdit,
            _id: '',
            dni: '',
            salario_dia: 0,
            turno: '',
            name: '',
            direccion: '',
            email: '',
            password: '',
            autoridad: '',
            imagen: '',
            bloqueado: false
        })

        setPreview({ ...preview, imagen: '' })
        setPreviewEdit({ ...preview, imagen: '' })
    }

    const imageHandle = e => {
        if (e.target.files.length !== 0) {
            setState({ ...state, [e.target.name]: e.target.files[0] });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview({ ...preview, [e.target.name]: reader.result })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const imageHandleEdit = e => {
        if (e.target.files.length !== 0) {
            setStateEdit({ ...stateEdit, [e.target.name]: e.target.files[0] });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewEdit({ ...previewEdit, [e.target.name]: reader.result })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    function handleEdit(row) {

        setStateEdit({
            ...stateEdit,
            _id: row._id,
            dni: row.dni,
            salario_dia: row.salario_dia,
            turno: row.turno,
            name: row.name,
            direccion: row.direccion,
            email: row.email,
            password: '',
            autoridad: row.autoridad,
            currentimagen: row.photo,
            imagen: '',
            bloqueado: row.bloqueado,
            last_update: row.last_update,
            created_at: row.created_at
        })
        editar.onOpen()
    }

    function handleDelete(row) {
        alertaConfirmar('Eliminar Usuario', `Estas seguro que quieres eliminar la usuario <b>${row.name}</b>? recuerda que se eliminarán todos los datos relacionados a este.`, 'question', async (res_alert) => {
            if (res_alert === true) {
                await dispatch(del({ _id: row._id, userId: userToken && user.id }));
            }
        })
    }

    const handleInputs = e => {
        setState({ ...state, [e.target.name]: e.target.value })
    }

    const handleEditInputs = e => {
        setStateEdit({ ...stateEdit, [e.target.name]: e.target.value })
    }

    const onSubmitRegistrar = async e => {
        e.preventDefault();
        if (state.name.trim().length < 5) {
            alerta('nombre es requeridos', 'error', 4)
        } else if (!validarEMAIL(state.email)) {
            alerta('email no es válido', 'error', 4)
        } else if (state.salario_dia < 0) {
            alerta('salario no es válido', 'error', 4)
        } else if (!validarDNI(state.dni)) {
            alerta('DNI inválido', 'error', 4)
        } else if (state.password.trim().length < 8) {
            alerta('password en min 8 caracteres', 'error', 4)
        } else if (state.autoridad.trim() < 1) {
            alerta('autoridad es requerido', 'error', 4)
        } else if (state.turno.trim() < 1) {
            alerta('turno es requerido', 'error', 4)
        } else {
            const formData = new FormData();
            formData.append('data', JSON.stringify(state));
            formData.append('imagen', state.imagen);
            await dispatch(create(formData));
        }
    }

    const onSubmitEditar = async e => {
        e.preventDefault();
        if (stateEdit.name.trim().length < 5) {
            alerta('nombre es requeridos', 'error', 4)
        } else if (!validarEMAIL(stateEdit.email)) {
            alerta('email no es válido', 'error', 4)
        } else if (stateEdit.salario_dia < 0) {
            alerta('salario no es válido', 'error', 4)
        } else if (!validarDNI(stateEdit.dni)) {
            alerta('DNI inválido', 'error', 4)
        } else if (stateEdit.password.trim().length < 8 && stateEdit.password.trim().length > 0) {
            alerta('password en min 8 caracteres', 'error', 4)
        } else if (stateEdit.autoridad.trim() < 1) {
            alerta('autoridad es requerido', 'error', 4)
        } else if (stateEdit.turno.trim() < 1) {
            alerta('turno es requerido', 'error', 4)
        } else {
            const formData = new FormData();
            formData.append('data', JSON.stringify(stateEdit));
            formData.append('imagen', stateEdit.imagen);
            await dispatch(update(formData));
        }
    }

    useEffect(() => {
        if (isMutation.success) {
            alerta(isMutation.message, 'success', 5)
            if (registrar.isOpen) {
                registrar.onClose()
                setDefaultState()
            }
            dispatch(SET_TO_DEFAULT_RESPONSE())
        }
    }, [isMutation.success])

    useEffect(() => {
        if (isMutation.updated) {
            alerta(isMutation.message, 'success', 5)
            if (editar.isOpen) {
                editar.onClose()
                setDefaultState()
            }
            dispatch(SET_TO_DEFAULT_RESPONSE())
        }
    }, [isMutation.updated])

    const fetchData = useCallback(
        (pageSize, pageIndex, search, order) => {
            const queryOptions = {
                page: pageIndex,
                limit: pageSize,
                search: search,
                order: order,
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            dispatch(getByPage(query))
        },
        [isMutation.success]
    )

    useEffect(() => {
        if (responseGetByDocumentId) {
            if (registrar.isOpen) {
                setState({
                    ...state, name:
                        responseGetByDocumentId.apellidoPaterno + ' ' +
                        responseGetByDocumentId.apellidoMaterno + ' ' +
                        responseGetByDocumentId.nombres
                })
            } else if (editar.isOpen) {
                setStateEdit({
                    ...stateEdit, name:
                        responseGetByDocumentId.apellidoPaterno + ' ' +
                        responseGetByDocumentId.apellidoMaterno + ' ' +
                        responseGetByDocumentId.nombres
                })
            }
        }
        dispatch(SET_TO_DEFAULT_RESPONSE_CONSULTA_RENIEC())
    }, [responseGetByDocumentId])

    const onChangeSearchTerm = e => {
        setSearchTerm(e.target.value);
    };

    const onChangeSearchTermClear = e => {
        setSearchTerm("");
        document.getElementById("search").value = "";
    };

    const debounceSearchTerm = useMemo(() => debounce(onChangeSearchTerm, 700), []);


    const onSubmitConsultarReniec = async () => {
        if ((registrar.isOpen && !validarDNI(state.dni)) || (editar.isOpen && !validarDNI(stateEdit.dni))) {
            alerta('DNI inválido', 'error', 5)
        } else {
            const queryOptions = {
                number: registrar.isOpen ? state.dni : stateEdit.dni,
                type: 'dni',
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            await dispatch(getByDocumentId({ query: query, token: userToken }))
        }
    }

    return (
        <div className="mt-4 md:mt-0">
            <div className="sticky z-30 w-full top-44 md:top-28 flex items-center justify-end bg-white dark:!bg-navy-800 p-2 rounded-xl shadow-xl shadow-gray-200 dark:shadow-none">
                <div className="relative flex h-[61px] w-[calc(100%-55px)] flex-grow items-center gap-2 rounded-full bg-white px-0 py-2 dark:!bg-navy-800">
                    <InputGroup className="!w-full md:!w-[300px]">
                        <InputLeftElement pointerEvents="none" className="!mt-1 !ml-1">
                            <FiSearch size={24} className="text-navy-500 dark:text-navy-300" />
                        </InputLeftElement>
                        <Input size='lg' autoFocus id="search" onChange={debounceSearchTerm} type="text" placeholder={`Buscar ${totalRow} usuarios...`} className="flex w-full items-center justify-center !rounded-xl border !bg-lightPrimary 
            dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
            focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
            !outline-none !border-gray-200 dark:!border-white/10 dark:text-white" />
                        <InputRightElement className="!mt-1">
                            <CloseButton onClick={onChangeSearchTermClear} size='md' className={`mr-2 ${searchTerm.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-navy-500 dark:text-navy-300`} />
                        </InputRightElement>
                    </InputGroup>
                </div>
                <div className="w-[55px] h-[61px] flex items-center">
                    <TooltipComponent
                        trigger={<button onClick={registrar.onOpen} className="bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-3 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white">
                            <FaPlusCircle />
                        </button>}
                        content={
                            <p className="dark:text-white">
                                registrar usuario
                            </p>
                        }
                    />
                </div>
            </div>
            <div className="mt-3 md:mt-8">

                {/** REGISTRAR */}
                <Modal isOpen={registrar.isOpen} onClose={registrar.onClose} headerTitle='Registrar usuario'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitRegistrar} autoComplete="off">
                            <div className="flex flex-wrap">
                                <div className="w-full flex items-center justify-center">
                                    <div class="relative w-56 h-56 rounded-full bg-neutral-50 dark:bg-neutral-950 flex inline-flex items-center justify-center">
                                        <label htmlFor="imagen" class="absolute z-20 cursor-pointer top-0 left-0 bg-brand-500 dark:bg-brand-400 contrast-[80%] rounded-full p-3">
                                            <MdPhotoCamera size={32} className="text-white dark:text-white" />
                                            <input id="imagen" accept="image/png,image/jpeg,image/webp" type="file" name="imagen" class="hidden" onChange={imageHandle} />
                                        </label>
                                        {
                                            preview.imagen ? <PhotoPreview url={preview.imagen} /> :
                                                <LazyLoadImage
                                                    className="w-56 h-56 rounded-full object-cover flex inline-flex"
                                                    alt={`No image`}
                                                    effect="black-and-white"
                                                    src={`/images/usuarios/unknowphoto.webp`}
                                                />
                                        }
                                    </div>
                                </div>

                                <InputField
                                    autoFocus={true}
                                    variant="input"
                                    required={true}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Email"
                                    placeholder="Email"
                                    id="email"
                                    type="email"
                                    name="email"
                                    onChange={handleInputs}
                                    value={state.email}
                                />

                                <InputField
                                    iconright={<IconButton colorScheme={'brand'} onClick={() => SetVerPasswords({ ...VerPasswords, ['password']: !VerPasswords.password })} type="button">
                                        {VerPasswords.password ? <IoEyeOff size={24} className="!text-brand-500 dark:!text-brand-400" /> : <IoEye size={24} className="!text-brand-500 dark:!text-brand-400" />}
                                    </IconButton>}
                                    required={true}
                                    AutoComplete="off"
                                    variant="auth"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Contraseña"
                                    placeholder="Min. 8 caracteres"
                                    id="password"
                                    type={VerPasswords.password ? 'text' : 'password'}
                                    name="password"
                                    onChange={handleInputs}
                                    value={state.password}
                                />

                                <InputField
                                    variant="input"
                                    required={true}
                                    disabled={isLoadingConsultaReniec}
                                    iconright={<IoSearch className="text-brand-600 dark:text-brand-400" size={!24} />}
                                    onClickIconRight={onSubmitConsultarReniec}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Número de documento"
                                    placeholder="Número de documento"
                                    id="dni"
                                    type="text"
                                    name="dni"
                                    onChange={handleInputs}
                                    value={state.dni}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    extraInput="uppercase"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    id="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputs}
                                    value={state.name}
                                />

                                <InputField
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Dirección"
                                    placeholder="Dirección"
                                    id="direccion"
                                    type="text"
                                    name="direccion"
                                    onChange={handleInputs}
                                    value={state.direccion}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Salario diario"
                                    placeholder="Salario diario"
                                    min={1}
                                    max={200}
                                    id="salario_dia"
                                    type="number"
                                    name="salario_dia"
                                    onChange={handleInputs}
                                    value={state.salario_dia}
                                />

                                <AutoComplete
                                    autoFocus={true}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Turno"
                                    data={[
                                        { tipo: 'completo' }, { tipo: 'mañana' },
                                        { tipo: 'tarde' }, { tipo: 'noche' }
                                    ]}
                                    value={state.turno}
                                    required={true}
                                    labelProp="tipo"
                                    valueProp="tipo"
                                    onChange={(val) => setState({ ...state, turno: val })}
                                />

                                <AutoComplete
                                    autoFocus={true}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Autoridad"
                                    data={[
                                        { tipo: 'ADMIN' }, { tipo: 'CAJERO' },
                                        { tipo: 'VENDEDOR' }
                                    ]}
                                    value={state.autoridad}
                                    required={true}
                                    labelProp="tipo"
                                    valueProp="tipo"
                                    onChange={(val) => setState({ ...state, autoridad: val })}
                                />

                                <SwitchToggle
                                    extra="w-full mb-3 p-2"
                                    label="Estado"
                                    id="bloqueado"
                                    onClick={() => setState({
                                        ...state,
                                        bloqueado: !state.bloqueado
                                    })}
                                    value={state.bloqueado}
                                />

                                <ButtonPrimary isLoading={isMutation.loading} disabled={false} icon={<IoAddCircle size={28} />}>
                                    Registrar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                {/** EDITAR */}
                <Modal isOpen={editar.isOpen} onClose={editar.onClose} headerTitle='Editar usuario'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitEditar}>
                            <div className="flex flex-wrap">
                                <div className="w-full flex items-center justify-center">
                                    <div class="relative w-56 h-56 rounded-full bg-neutral-50 dark:bg-neutral-950 flex inline-flex items-center justify-center">
                                        <label htmlFor="imagen" class="absolute z-20 cursor-pointer top-0 left-0 bg-brand-500 dark:bg-brand-400 contrast-[80%] rounded-full p-3">
                                            <MdPhotoCamera size={32} className="text-white dark:text-white" />
                                            <input id="imagen" accept="image/png,image/jpeg,image/webp" type="file" name="imagen" class="hidden" onChange={imageHandleEdit} />
                                        </label>
                                        {
                                            previewEdit.imagen ? <PhotoPreview url={previewEdit.imagen} /> :
                                                <LazyLoadImage
                                                    className="w-56 h-56 rounded-full object-cover flex inline-flex"
                                                    alt={`No image`}
                                                    effect="black-and-white"
                                                    src={`/images/usuarios/${stateEdit.currentimagen}`}
                                                />
                                        }
                                    </div>
                                </div>

                                <InputField
                                    autoFocus={true}
                                    variant="input"
                                    required={true}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Email"
                                    placeholder="Email"
                                    id="email"
                                    type="email"
                                    name="email"
                                    onChange={handleEditInputs}
                                    value={stateEdit.email}
                                />

                                <InputField
                                    iconright={<IconButton colorScheme={'brand'} onClick={() => SetVerPasswords({ ...VerPasswords, ['password']: !VerPasswords.password })} type="button">
                                        {VerPasswords.password ? <IoEyeOff size={24} className="!text-brand-500 dark:!text-brand-400" /> : <IoEye size={24} className="!text-brand-500 dark:!text-brand-400" />}
                                    </IconButton>}
                                    required={false}
                                    AutoComplete="off"
                                    variant="auth"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Contraseña"
                                    placeholder="Min. 8 caracteres"
                                    id="password"
                                    type={VerPasswords.password ? 'text' : 'password'}
                                    name="password"
                                    onChange={handleEditInputs}
                                    value={stateEdit.password}
                                    helperText="dejar en blanco sino vas a modificar"
                                />

                                <InputField
                                    variant="input"
                                    required={true}
                                    disabled={isLoadingConsultaReniec}
                                    iconright={<IoSearch className="text-brand-600 dark:text-brand-400" size={!24} />}
                                    onClickIconRight={onSubmitConsultarReniec}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Número de documento"
                                    placeholder="Número de documento"
                                    id="dni"
                                    type="text"
                                    name="dni"
                                    onChange={handleEditInputs}
                                    value={stateEdit.dni}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    extraInput="uppercase"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    id="name"
                                    type="text"
                                    name="name"
                                    onChange={handleEditInputs}
                                    value={stateEdit.name}
                                />

                                <InputField
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Dirección"
                                    placeholder="Dirección"
                                    id="direccion"
                                    type="text"
                                    name="direccion"
                                    onChange={handleEditInputs}
                                    value={stateEdit.direccion}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Salario diario"
                                    placeholder="Salario diario"
                                    min={1}
                                    max={200}
                                    id="salario_dia"
                                    type="number"
                                    name="salario_dia"
                                    onChange={handleEditInputs}
                                    value={stateEdit.salario_dia}
                                />

                                <AutoComplete
                                    autoFocus={true}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Turno"
                                    data={[
                                        { tipo: 'completo' }, { tipo: 'mañana' },
                                        { tipo: 'tarde' }, { tipo: 'noche' }
                                    ]}
                                    value={stateEdit.turno}
                                    required={true}
                                    labelProp="tipo"
                                    valueProp="tipo"
                                    onChange={(val) => setStateEdit({ ...stateEdit, turno: val })}
                                />

                                <AutoComplete
                                    autoFocus={true}
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Autoridad"
                                    data={[
                                        { tipo: 'ADMIN' }, { tipo: 'CAJERO' },
                                        { tipo: 'VENDEDOR' }
                                    ]}
                                    value={stateEdit.autoridad}
                                    required={true}
                                    labelProp="tipo"
                                    valueProp="tipo"
                                    onChange={(val) => setStateEdit({ ...stateEdit, autoridad: val })}
                                />

                                <SwitchToggle
                                    extra="w-full mb-3 p-2"
                                    label="Estado"
                                    id="bloqueado"
                                    onClick={() => setStateEdit({
                                        ...stateEdit,
                                        bloqueado: !stateEdit.bloqueado
                                    })}
                                    value={stateEdit.bloqueado}
                                />

                                <InputField
                                    required={false}
                                    readOnly={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Fecha de registro"
                                    placeholder="Fecha de registro"
                                    id="created_at"
                                    type="text"
                                    name="created_at"
                                    value={moment(stateEdit.created_at).format('dddd, D [de] MMMM [de] YYYY, h:mm a')}
                                />

                                <InputField
                                    required={false}
                                    readOnly={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Última vez que se actualizó"
                                    placeholder="Última vez que se actualizó"
                                    id="created_at"
                                    type="text"
                                    name="created_at"
                                    value={moment(stateEdit.last_update).format('dddd, D [de] MMMM [de] YYYY, h:mm a')}
                                />

                                <ButtonPrimary isLoading={isMutation.loading} disabled={false} icon={<FaEdit size={28} />}>
                                    Editar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                <div className="mt-5 grid h-full grid-cols-1">

                    <TablePagination
                        searchTerm={searchTerm}
                        tableData={dataByPage}
                        fetchData={fetchData}
                        loading={isMutation.loading}
                        pageCount={totalPage}
                        totalRow={totalRow}
                        actions={{
                            onEdit: (item) => handleEdit(item),
                            onDelete: (item) => handleDelete(item)
                        }}
                    />
                </div>
            </div>
        </div >

    );
};

export default Usuarios;
